import React from 'react';

const UserInfoSimple = ({ name, lastName, email }) => {
  return (
    <div className="d-flex align-items-center">
      <i className="fa fa-user-circle" style={{ fontSize: '30px', marginRight: '8px' }}></i>
      <div>
        <span style={{ fontSize: '20px', lineHeight: '1' }}>{`${name} ${lastName}`}</span>
        <div className="text-muted" style={{ fontSize: '16px', lineHeight: '1' }}>
          {email}
        </div>
      </div>
    </div>
  );
};

export default UserInfoSimple;
